import React, { useCallback, useEffect, useState } from "react";
import { uploadFile, uploadGift } from "../../DAL/create";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  TextField,
  MenuItem,
  FormHelperText,
} from "@mui/material";

import SVGAAnimation from "../../Components/SVGAAnimation";
import { useNavigate, useParams } from "react-router-dom";
import { fetchGiftById } from "../../DAL/fetch";
import { updateGiftData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

function CreateGift() {
  const navigate = useNavigate();
  const params = useParams();
  const [formType, setFormType] = useState("Add");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [fileName, setFileName] = useState("");
  const [file2, setFile2] = useState(null);
  const [fileName2, setFileName2] = useState("");
  const [fileUploaded1, setFileUploaded1] = useState(false);
  const [fileUploaded2, setFileUploaded2] = useState(false);
  const [fileURL1, setFileURL1] = useState("");
  const [fileURL2, setFileURL2] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [filePreview2, setFilePreview2] = useState(null);
  const [name, setName] = useState("");
  const [dimond, setDimond] = useState("");
  const [type, setType] = useState("");
  const [message, setMessage] = useState(false);

  const isFormIncomplete =
    formType === "Add" && (!file || !file2 || !name || !dimond || !type);
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : "");
    setFileUploaded1(false);
    setFilePreview(URL.createObjectURL(selectedFile));
  };

  const handleFileChange2 = (e) => {
    const selectedFile2 = e.target.files[0];

  
    setFile2(selectedFile2);
    setFileName2(selectedFile2 ? selectedFile2.name : "");
    setFileUploaded2(false);
    setFilePreview2(URL.createObjectURL(selectedFile2));
  };

  const handleFileSubmit1 = async (e) => {
    e.preventDefault();
    if (!filePreview && formType === "Add") {
      setMessage(true);
      return;
    }
    if (!filePreview2 && formType === "Add") {
      setMessage(true);
      return;
    }
    if (!file) {
      setMessage(true);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    try {
      const imagedata = await uploadFile(formData);
      setFileURL1(imagedata.data.url);
      setFileUploaded1(true);
      enqueueSnackbar("File uploaded successfully!", { variant: "success" });
    } catch (error) {
      console.error("Error uploading file:", error);
      enqueueSnackbar("Failed to upload file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFileSubmit2 = async (e) => {
    e.preventDefault();
    if (!file2) {
      setMessage(true);
      return;
    }

    const formData = new FormData();
    formData.append("image", file2);

    setLoading2(true);
    try {
      const animationdata = await uploadFile(formData);
      setFileURL2(animationdata.data.url);
      setFileUploaded2(true);
      enqueueSnackbar("Second file uploaded successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error uploading second file:", error);
      enqueueSnackbar("Failed to upload second file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading2(false);
    }
  };

  const FetchGiftDetail = useCallback(async () => {
    const resp = await fetchGiftById(params?.id);
    if (resp?.status == 200) {
      setFormType("Update");
      setName(resp?.data?.name);
      setDimond(resp?.data?.diamond);
      setType(resp?.data?.type);
      setFileURL1(resp?.data?.pictureUrl);
      setFilePreview(resp?.data?.pictureUrl);
      setFileURL2(resp?.data?.animationUrl);
      setFilePreview2(resp?.data?.animationUrl);
    } else {
      enqueueSnackbar(resp?.message, { variant: "error" });
    }
  }, [params?.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) {
      setMessage(true);
      return;
    }
    if (!dimond) {
      setMessage(true);
      return;
    }
    if (!type) {
      setMessage(true);
      return;
    }
    if (!file && formType == "Add") {
      setMessage(true);
      return;
    }

    const formData = new FormData();

    formData.append("name", name);
    formData.append("diamond", Number(dimond));
    formData.append("pictureUrl", fileURL1);
    formData.append("animationUrl", fileURL2);
    formData.append("type", type);
    const Payload = {
      name,
      diamond: Number(dimond),
      pictureUrl: fileURL1,
      animationUrl: fileURL2,
      type,
    };
    setLoading(true);
    try {
      let res;
      if (formType === "Add") {
        res = await uploadGift(Payload);
      } else {
        res = await updateGiftData(params?.id, Payload);
      }
      if (res?.status === 201 || res?.status === 200) {
        enqueueSnackbar(
          formType === "Add"
            ? "Gift added successfully!"
            : "Gift updated successfully!",
          { variant: "success" }
        );
        navigate("/giftlist");
      } else {
        enqueueSnackbar("Failed to upload Gift. Please try again.", {
          variant: "error",
        });
      }
      // enqueueSnackbar(
      //   formType == "Add"
      //     ? "Gift added successfully!"
      //     : "Gift updated successfully!",
      //   { variant: "success" }
      // );
      // navigate("/giftlist");
    } catch (error) {
      console.error("Error uploading Gift:", error);
      enqueueSnackbar("Failed to upload Gift. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params?.id) {
      FetchGiftDetail();
    }
  }, [params?.id]);

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
        maxWidth: 400,
        margin: "auto",
        mt: 4,
      }}
    >
      <Typography id="modal-title" variant="h6" component="h2">
        {formType == "Add" ? "Add New Gift" : "Update Gift"}
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Box>
          <TextField
            sx={inputStyles}
            InputLabelProps={{ sx: labelStyles }}
            fullWidth
            required
            label="Gift Name"
            variant="outlined"
            name="name"
            value={name}
            inputProps={{ maxLength: 30 }}
            onChange={(e) => setName(e.target.value)}
          />
          <FormHelperText sx={{ color: "red" }}>
            {message == true && !name && "Gifter Name is Required"}
          </FormHelperText>
        </Box>
        <Box>
          <TextField
            sx={inputStyles}
            InputLabelProps={{ sx: labelStyles }}
            fullWidth
            required
            label="Dimond"
            variant="outlined"
            name="dimond"
            type="number"
            value={dimond}
            onChange={(e) =>
              setDimond(Number(e.target.value < 0 ? 0 : e.target.value))
            }
          />
          <FormHelperText sx={{ color: "red" }}>
            {message == true && !dimond && "Diamond is Required"}
          </FormHelperText>
        </Box>
      </Box>

      <TextField
        select
        fullWidth
        required
        label="Type"
        value={type}
        onChange={(e) => setType(e.target.value)}
        variant="outlined"
        name="Type"
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      >
        <MenuItem value="Normal">Normal</MenuItem>
        <MenuItem value="Lucky">Lucky</MenuItem>
        <MenuItem value="Entrance Effect">Entrance Effect</MenuItem>
      </TextField>
      <FormHelperText sx={{ color: "red" }}>
        {message == true && !type && "Type is Required"}
      </FormHelperText>

      <Typography variant="h6">Upload Image 1</Typography>

      <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <Button
          variant="contained"
          color={fileUploaded1 ? "success" : "primary"}
          onClick={handleFileSubmit1}
          disabled={loading || !file}
          sx={{ textTransform: "none" }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : fileUploaded1 ? (
            "Uploaded"
          ) : (
            "Upload"
          )}
        </Button>
      </Box>
      {fileName && <Typography variant="body2">{fileName}</Typography>}
      <FormHelperText sx={{ color: "red" }}>
        {message && !filePreview && "Image is Required"}
      </FormHelperText>
      {filePreview && (
        <Box sx={{ mt: 2 }}>
          <img
            src={filePreview}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "200px" }}
          />
        </Box>
      )}

      <Typography variant="h6">Upload Animation SVGA</Typography>

      <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
        <input type="file" accept=".svga" onChange={handleFileChange2} />
        <Button
          variant="contained"
          color={fileUploaded2 ? "success" : "primary"}
          onClick={handleFileSubmit2}
          disabled={loading2 || !file2}
          sx={{ textTransform: "none" }}
        >
          {loading2 ? (
            <CircularProgress size={24} color="inherit" />
          ) : fileUploaded2 ? (
            "Uploaded"
          ) : (
            "Upload"
          )}
        </Button>
      </Box>
      {fileName2 && <Typography variant="body2">{fileName2}</Typography>}
      <FormHelperText sx={{ color: "red" }}>
        {message && !filePreview2 && "SVGA is Required"}
      </FormHelperText>

      {filePreview2 && (
        <Box sx={{ mt: 2 }}>
          <SVGAAnimation animationUrl={filePreview2} />
        </Box>
      )}
      <Button
        variant="contained"
        className="gradientButton"
        disabled={isFormIncomplete}
        onClick={handleSubmit}
        fullWidth
        sx={{ textTransform: "none" }}
      >
        {formType == "Add" ? "Submit Gift" : "Update Gift"}
      </Button>
    </Box>
  );
}

export default CreateGift;
